var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/img/app-store-badge.png": "e130",
	"./assets/img/en_meals_guide.jpg": "a909",
	"./assets/img/en_payments_guide.jpg": "44eb",
	"./assets/img/flags/austria.svg": "c606",
	"./assets/img/flags/canada.svg": "0600",
	"./assets/img/flags/catalonia.svg": "4f7c",
	"./assets/img/flags/flag_basque.png": "ccc2",
	"./assets/img/flags/flag_galicia.png": "ee76",
	"./assets/img/flags/flag_valencian.png": "0c20",
	"./assets/img/flags/germany.svg": "aac1",
	"./assets/img/flags/mexico.webp": "e658",
	"./assets/img/flags/mx.png": "66c6",
	"./assets/img/flags/poland.svg": "e05b",
	"./assets/img/flags/sa.png": "55d8",
	"./assets/img/flags/slovakia.svg": "6d2b",
	"./assets/img/flags/soam.png": "2c3be",
	"./assets/img/flags/spain.svg": "b773",
	"./assets/img/flags/switzerland.svg": "efe8",
	"./assets/img/flags/uk.png": "0e526",
	"./assets/img/flags/ukraine.svg": "2b88",
	"./assets/img/flags/united-kingdom.svg": "d393",
	"./assets/img/google-play-badge.png": "6878",
	"./assets/img/has_account.svg": "e8d8",
	"./assets/img/livekid-novakid.png": "3047",
	"./assets/img/login-background.svg": "8e93",
	"./assets/img/logo-blocks.svg": "252c",
	"./assets/img/logo.svg": "1ae4",
	"./assets/img/mati.jpg": "c11f",
	"./assets/img/new_account.svg": "411c",
	"./assets/img/novakid.svg": "9412",
	"./assets/img/novakid_logos.png": "eeac",
	"./assets/img/novakid_start.png": "1334",
	"./assets/img/pl_meals_guide.jpg": "e7f0",
	"./assets/img/pl_payments_guide.jpg": "127c",
	"./assets/img/signup-parent-type.svg": "d02e",
	"./assets/img/signup-school-type.svg": "f6cf",
	"./assets/img/signup-teacher-type.svg": "7b14",
	"./assets/img/sk_meals_guide.jpg": "50c1",
	"./assets/img/sk_payments_guide.jpg": "439e",
	"./assets/img/vod_logo.svg": "a5b3",
	"./assets/scss/bulma.scss": "bc7f",
	"./assets/scss/colors.scss": "6cab",
	"./assets/scss/variables.scss": "2295",
	"./components/Modal": "714b",
	"./components/Modal.vue": "714b",
	"./components/forms/ActionButton": "4f99",
	"./components/forms/ActionButton.vue": "4f99",
	"./components/forms/Checkbox": "e902",
	"./components/forms/Checkbox.vue": "e902",
	"./components/forms/DatePicker": "e8b6",
	"./components/forms/DatePicker.vue": "e8b6",
	"./components/forms/EditSection": "e06e",
	"./components/forms/EditSection.vue": "e06e",
	"./components/forms/LoginSelectInput": "3105",
	"./components/forms/LoginSelectInput.vue": "3105",
	"./components/forms/LoginTextInput": "d5b8",
	"./components/forms/LoginTextInput.vue": "d5b8",
	"./components/forms/MonthPicker": "f28e",
	"./components/forms/MonthPicker.vue": "f28e",
	"./components/forms/SectionDateSelector": "2eaf",
	"./components/forms/SectionDateSelector.vue": "2eaf",
	"./components/forms/SectionMultiSelector": "95f2",
	"./components/forms/SectionMultiSelector.vue": "95f2",
	"./components/forms/SectionSingleSelector": "9a3f",
	"./components/forms/SectionSingleSelector.vue": "9a3f",
	"./components/forms/SectionTextInput": "3e66",
	"./components/forms/SectionTextInput.vue": "3e66",
	"./components/forms/SingleSelector": "1ea6",
	"./components/forms/SingleSelector.vue": "1ea6",
	"./components/forms/TextButton": "de67",
	"./components/forms/TextButton.vue": "de67",
	"./components/forms/TimePicker": "1a9e",
	"./components/forms/TimePicker.vue": "1a9e",
	"./components/tools/AppLoading": "3f1e",
	"./components/tools/AppLoading.vue": "3f1e",
	"./components/tools/ListLoader": "14c0",
	"./components/tools/ListLoader.vue": "14c0",
	"./components/tools/ListPlaceholder": "36ca",
	"./components/tools/ListPlaceholder.vue": "36ca",
	"./components/tools/Notifications": "d1cc",
	"./components/tools/Notifications.vue": "d1cc",
	"./components/tools/RightClickMenu": "ecee",
	"./components/tools/RightClickMenu.vue": "ecee",
	"./components/tools/SelectorWrap": "fc87",
	"./components/tools/SelectorWrap.vue": "fc87",
	"./env.d": "df4f",
	"./env.d.ts": "df4f",
	"./globalProps": "22ff",
	"./globalProps.ts": "22ff",
	"./helpers/AppLoader": "fbf1",
	"./helpers/AppLoader.js": "fbf1",
	"./helpers/Language": "d1a4",
	"./helpers/Language.js": "d1a4",
	"./helpers/SocketService": "25b6",
	"./helpers/SocketService.js": "25b6",
	"./helpers/account": "62e0",
	"./helpers/account.ts": "62e0",
	"./helpers/analytics": "2761",
	"./helpers/analytics.js": "2761",
	"./helpers/api": "fd54",
	"./helpers/api.ts": "fd54",
	"./helpers/apiService": "fb63",
	"./helpers/apiService.js": "fb63",
	"./helpers/currencyTranslator": "37a2",
	"./helpers/currencyTranslator.js": "37a2",
	"./helpers/date": "97be",
	"./helpers/date.ts": "97be",
	"./helpers/env": "1b08",
	"./helpers/env.js": "1b08",
	"./helpers/network": "3fb9",
	"./helpers/network.js": "3fb9",
	"./helpers/notif": "d07d",
	"./helpers/notif.js": "d07d",
	"./helpers/query": "e800",
	"./helpers/query.js": "e800",
	"./helpers/school": "e23c",
	"./helpers/school.ts": "e23c",
	"./helpers/sentry": "240f",
	"./helpers/sentry.js": "240f",
	"./helpers/utils": "a2b6",
	"./helpers/utils.js": "a2b6",
	"./i18n": "12cb",
	"./i18n/": "12cb",
	"./i18n/index": "12cb",
	"./i18n/index.js": "12cb",
	"./main": "56d7",
	"./main.js": "56d7",
	"./modules/globalComponents": "c1fb",
	"./modules/globalComponents.js": "c1fb",
	"./modules/globalModules": "7af9",
	"./modules/globalModules.js": "7af9",
	"./network/novaApi": "eebc",
	"./network/novaApi.js": "eebc",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/ParentApply/ApplyByLogin": "8cda",
	"./views/ParentApply/ApplyByLogin.vue": "8cda",
	"./views/ParentApply/ApplyByRegister": "3bcf",
	"./views/ParentApply/ApplyByRegister.vue": "3bcf",
	"./views/ParentApply/ApplyType": "0a36",
	"./views/ParentApply/ApplyType.vue": "0a36",
	"./views/ParentApply/ContractFormRender": "c291",
	"./views/ParentApply/ContractFormRender.vue": "c291",
	"./views/ParentApply/ParentApply": "b0b1",
	"./views/ParentApply/ParentApply.vue": "b0b1",
	"./views/ParentApply/ParentForm": "8f2f",
	"./views/ParentApply/ParentForm.vue": "8f2f",
	"./views/PreLoginView/LoginSelectInput": "1024",
	"./views/PreLoginView/LoginSelectInput.vue": "1024",
	"./views/PreLoginView/LoginTextInput": "3455",
	"./views/PreLoginView/LoginTextInput.vue": "3455",
	"./views/PreLoginView/PasswordStrength": "357f",
	"./views/PreLoginView/PasswordStrength.vue": "357f",
	"./views/PreLoginView/PreLoginButton": "3087",
	"./views/PreLoginView/PreLoginButton.vue": "3087",
	"./views/PreLoginView/PreLoginDatepicker": "76dd",
	"./views/PreLoginView/PreLoginDatepicker.vue": "76dd",
	"./views/PreLoginView/PreLoginForm": "e266",
	"./views/PreLoginView/PreLoginForm.vue": "e266",
	"./views/PreLoginView/PreLoginLanguageSelector": "c742",
	"./views/PreLoginView/PreLoginLanguageSelector.vue": "c742",
	"./views/PreLoginView/PreLoginView": "c94d",
	"./views/PreLoginView/PreLoginView.vue": "c94d",
	"./views/catering/CateringContactForm": "7088",
	"./views/catering/CateringContactForm.vue": "7088",
	"./views/catering/CateringOrder": "9174",
	"./views/catering/CateringOrder.vue": "9174",
	"./views/insurance/Insurance": "2f79",
	"./views/insurance/Insurance.vue": "2f79",
	"./views/login/BadQr": "a084",
	"./views/login/BadQr.vue": "a084",
	"./views/login/QRHandlingView": "16e2",
	"./views/login/QRHandlingView.vue": "16e2",
	"./views/login/Signup": "2a5c",
	"./views/login/Signup.vue": "2a5c",
	"./views/login/SignupForm": "6fde",
	"./views/login/SignupForm.vue": "6fde",
	"./views/login/Status": "d83c",
	"./views/login/Status.vue": "d83c",
	"./views/nova/NovaSchool": "da56",
	"./views/nova/NovaSchool.vue": "da56",
	"./views/nova/components/NovaEmailForm": "564d",
	"./views/nova/components/NovaEmailForm.vue": "564d",
	"./views/nova/components/NovaScheduleForm": "7952",
	"./views/nova/components/NovaScheduleForm.vue": "7952",
	"./views/nova/components/NovaStart": "04b1",
	"./views/nova/components/NovaStart.vue": "04b1",
	"./views/nova/components/NovaStatus": "67f1",
	"./views/nova/components/NovaStatus.vue": "67f1",
	"./views/nova/components/NovakidPrivacyContent": "fed7",
	"./views/nova/components/NovakidPrivacyContent.vue": "fed7",
	"./views/nova/components/NovakidTerms": "d559",
	"./views/nova/components/NovakidTerms.vue": "d559",
	"./views/nova/components/NovakidTermsContent": "cc3e",
	"./views/nova/components/NovakidTermsContent.vue": "cc3e",
	"./views/reset/Reset": "8f6d",
	"./views/reset/Reset.vue": "8f6d",
	"./views/transaction/TransactionFinished": "6b71",
	"./views/transaction/TransactionFinished.vue": "6b71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";